// extracted by mini-css-extract-plugin
export default {"deniedPageContianer":"DeniedPayment_deniedPageContianer__noikm","iconWrapper":"DeniedPayment_iconWrapper__OT-wT"};